import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledBottomSheetContent = styled.div`
  textalign: left;
  alignitems: left;
  flexdirection: column;
  padding-bottom: 5%;

  ${({ theme }) => `
    line-height: ${theme.line.height.base};
    font-weight: ${theme.font.weight.normal};
    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.font.size.lg};
    }
  `}
`;

export const StyledNumber = styled.span`
  ${({ theme }) => `
    background-color: ${theme.colors.secondary.base};
    border-radius: 50%;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: ${theme.space.lg};
    width: ${theme.space.lg};
    margin-right: ${theme.space.md};
  `};
`;

export const StyledParagraph = styled(Type)`
  margin: 1rem 0 1rem 2.5rem;
`;
